/* tslint:disable */
/* eslint-disable */
/**
 * API Docs
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CancelRemarkShipmentCertificateRequest } from '../model';
// @ts-ignore
import { DeleteShipmentCertificateResponse } from '../model';
// @ts-ignore
import { GetIssueSuggestDateResponse } from '../model';
// @ts-ignore
import { GetListTreatmentIdShipmentResponse } from '../model';
// @ts-ignore
import { GetMaximumShipmentIssueDateResponse } from '../model';
// @ts-ignore
import { GetShipmentCertificatePreviewResponse } from '../model';
// @ts-ignore
import { GetShipmentCertificateResponse } from '../model';
// @ts-ignore
import { GetShipmentCertificatesResponse } from '../model';
// @ts-ignore
import { GetStatisticsResponse } from '../model';
// @ts-ignore
import { GetUncertificatedWeightResponse } from '../model';
// @ts-ignore
import { PostShipmentCertificateRequest } from '../model';
// @ts-ignore
import { PostShipmentCertificateResponse } from '../model';
// @ts-ignore
import { PutShipmentCertificateRequest } from '../model';
// @ts-ignore
import { PutShipmentCertificateResponse } from '../model';
/**
 * ShipmentCertificatesApi - axios parameter creator
 * @export
 */
export const ShipmentCertificatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PostShipmentCertificateRequest} postShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentCertificate: async (postShipmentCertificateRequest: PostShipmentCertificateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postShipmentCertificateRequest' is not null or undefined
            assertParamExists('createShipmentCertificate', 'postShipmentCertificateRequest', postShipmentCertificateRequest)
            const localVarPath = `/api/shipment-certificates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postShipmentCertificateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentCertificate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteShipmentCertificate', 'id', id)
            const localVarPath = `/api/shipment-certificates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostShipmentCertificateRequest} postShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueSuggestDate: async (postShipmentCertificateRequest: PostShipmentCertificateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postShipmentCertificateRequest' is not null or undefined
            assertParamExists('getIssueSuggestDate', 'postShipmentCertificateRequest', postShipmentCertificateRequest)
            const localVarPath = `/api/shipment-certificates/issue-suggest-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postShipmentCertificateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PostShipmentCertificateRequest} postShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaximumIssueDate: async (postShipmentCertificateRequest: PostShipmentCertificateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postShipmentCertificateRequest' is not null or undefined
            assertParamExists('getMaximumIssueDate', 'postShipmentCertificateRequest', postShipmentCertificateRequest)
            const localVarPath = `/api/shipment-certificates/maximum-shipment-issue-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postShipmentCertificateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentCertificate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getShipmentCertificate', 'id', id)
            const localVarPath = `/api/shipment-certificates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentCertificateByKeyword: async (keyword?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, status?: string, startDate?: string, endDate?: string , options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shipment-certificates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDesc !== undefined) {
                localVarQueryParameter['orderDesc'] = orderDesc;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentIdsInShipment: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shipment-certificates/getTreatmentIdsInShipment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} productName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeightsProduct: async (locationId: string, productName: string,treatmentRequests: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locationId' is not null or undefined
            assertParamExists('getWeightsProduct', 'locationId', locationId)
            // verify required parameter 'productName' is not null or undefined
            assertParamExists('getWeightsProduct', 'productName', productName)
            const localVarPath = `/api/shipment-certificates/getWeightsProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locationId !== undefined) {
                localVarQueryParameter['locationId'] = locationId;
            }

            if (productName !== undefined) {
                localVarQueryParameter['productName'] = productName;
            }
          

    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            if (treatmentRequests !== undefined) {
                localVarRequestOptions.data= {treatmentRequests: treatmentRequests};
            }

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewShipmentCertificate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('previewShipmentCertificate', 'id', id)
            const localVarPath = `/api/shipment-certificates/preview/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsDataShipment: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/shipment-certificates/statisticsData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {PutShipmentCertificateRequest} putShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentCertificate: async (id: string, putShipmentCertificateRequest: PutShipmentCertificateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateShipmentCertificate', 'id', id)
            // verify required parameter 'putShipmentCertificateRequest' is not null or undefined
            assertParamExists('updateShipmentCertificate', 'putShipmentCertificateRequest', putShipmentCertificateRequest)
            const localVarPath = `/api/shipment-certificates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putShipmentCertificateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} action 
         * @param {CancelRemarkShipmentCertificateRequest} cancelRemarkShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatusShipmentCertificate: async (id: string, action: string, cancelRemarkShipmentCertificateRequest: CancelRemarkShipmentCertificateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateStatusShipmentCertificate', 'id', id)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('updateStatusShipmentCertificate', 'action', action)
            // verify required parameter 'cancelRemarkShipmentCertificateRequest' is not null or undefined
            assertParamExists('updateStatusShipmentCertificate', 'cancelRemarkShipmentCertificateRequest', cancelRemarkShipmentCertificateRequest)
            const localVarPath = `/api/shipment-certificates/{id}/action/{action}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"action"}}`, encodeURIComponent(String(action)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancelRemarkShipmentCertificateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShipmentCertificatesApi - functional programming interface
 * @export
 */
export const ShipmentCertificatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShipmentCertificatesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PostShipmentCertificateRequest} postShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createShipmentCertificate(postShipmentCertificateRequest: PostShipmentCertificateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostShipmentCertificateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createShipmentCertificate(postShipmentCertificateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteShipmentCertificate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteShipmentCertificateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteShipmentCertificate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostShipmentCertificateRequest} postShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIssueSuggestDate(postShipmentCertificateRequest: PostShipmentCertificateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetIssueSuggestDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIssueSuggestDate(postShipmentCertificateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PostShipmentCertificateRequest} postShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaximumIssueDate(postShipmentCertificateRequest: PostShipmentCertificateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMaximumShipmentIssueDateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaximumIssueDate(postShipmentCertificateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentCertificate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetShipmentCertificateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentCertificate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShipmentCertificateByKeyword(keyword?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, status?: string, startDate?: string, endDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetShipmentCertificatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShipmentCertificateByKeyword(keyword, limit, page, orderBy, orderDesc, status, startDate, endDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTreatmentIdsInShipment(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetListTreatmentIdShipmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTreatmentIdsInShipment(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} productName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWeightsProduct(locationId: string, productName: string,treatmentRequests:Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUncertificatedWeightResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWeightsProduct(locationId, productName, treatmentRequests, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewShipmentCertificate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetShipmentCertificatePreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewShipmentCertificate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsDataShipment(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsDataShipment(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {PutShipmentCertificateRequest} putShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateShipmentCertificate(id: string, putShipmentCertificateRequest: PutShipmentCertificateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutShipmentCertificateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateShipmentCertificate(id, putShipmentCertificateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} action 
         * @param {CancelRemarkShipmentCertificateRequest} cancelRemarkShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStatusShipmentCertificate(id: string, action: string, cancelRemarkShipmentCertificateRequest: CancelRemarkShipmentCertificateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PutShipmentCertificateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatusShipmentCertificate(id, action, cancelRemarkShipmentCertificateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShipmentCertificatesApi - factory interface
 * @export
 */
export const ShipmentCertificatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShipmentCertificatesApiFp(configuration)
    return {
        /**
         * 
         * @param {PostShipmentCertificateRequest} postShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createShipmentCertificate(postShipmentCertificateRequest: PostShipmentCertificateRequest, options?: any): AxiosPromise<PostShipmentCertificateResponse> {
            return localVarFp.createShipmentCertificate(postShipmentCertificateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteShipmentCertificate(id: string, options?: any): AxiosPromise<DeleteShipmentCertificateResponse> {
            return localVarFp.deleteShipmentCertificate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostShipmentCertificateRequest} postShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssueSuggestDate(postShipmentCertificateRequest: PostShipmentCertificateRequest, options?: any): AxiosPromise<GetIssueSuggestDateResponse> {
            return localVarFp.getIssueSuggestDate(postShipmentCertificateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PostShipmentCertificateRequest} postShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaximumIssueDate(postShipmentCertificateRequest: PostShipmentCertificateRequest, options?: any): AxiosPromise<GetMaximumShipmentIssueDateResponse> {
            return localVarFp.getMaximumIssueDate(postShipmentCertificateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentCertificate(id: string, options?: any): AxiosPromise<GetShipmentCertificateResponse> {
            return localVarFp.getShipmentCertificate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [keyword] 
         * @param {number} [limit] 
         * @param {number} [page] 
         * @param {string} [orderBy] 
         * @param {string} [orderDesc] 
         * @param {string} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShipmentCertificateByKeyword(keyword?: string, limit?: number, page?: number, orderBy?: string, orderDesc?: string, status?: string, options?: any): AxiosPromise<GetShipmentCertificatesResponse> {
            return localVarFp.getShipmentCertificateByKeyword(keyword, limit, page, orderBy, orderDesc, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTreatmentIdsInShipment(options?: any): AxiosPromise<GetListTreatmentIdShipmentResponse> {
            return localVarFp.getTreatmentIdsInShipment(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locationId 
         * @param {string} productName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeightsProduct(locationId: string, productName: string, options?: any): AxiosPromise<GetUncertificatedWeightResponse> {
            return localVarFp.getWeightsProduct(locationId, productName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewShipmentCertificate(id: string, options?: any): AxiosPromise<GetShipmentCertificatePreviewResponse> {
            return localVarFp.previewShipmentCertificate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsDataShipment(options?: any): AxiosPromise<GetStatisticsResponse> {
            return localVarFp.statisticsDataShipment(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {PutShipmentCertificateRequest} putShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateShipmentCertificate(id: string, putShipmentCertificateRequest: PutShipmentCertificateRequest, options?: any): AxiosPromise<PutShipmentCertificateResponse> {
            return localVarFp.updateShipmentCertificate(id, putShipmentCertificateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} action 
         * @param {CancelRemarkShipmentCertificateRequest} cancelRemarkShipmentCertificateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatusShipmentCertificate(id: string, action: string, cancelRemarkShipmentCertificateRequest: CancelRemarkShipmentCertificateRequest, options?: any): AxiosPromise<PutShipmentCertificateResponse> {
            return localVarFp.updateStatusShipmentCertificate(id, action, cancelRemarkShipmentCertificateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createShipmentCertificate operation in ShipmentCertificatesApi.
 * @export
 * @interface ShipmentCertificatesApiCreateShipmentCertificateRequest
 */
export interface ShipmentCertificatesApiCreateShipmentCertificateRequest {
    /**
     * 
     * @type {PostShipmentCertificateRequest}
     * @memberof ShipmentCertificatesApiCreateShipmentCertificate
     */
    readonly postShipmentCertificateRequest: PostShipmentCertificateRequest
}

/**
 * Request parameters for deleteShipmentCertificate operation in ShipmentCertificatesApi.
 * @export
 * @interface ShipmentCertificatesApiDeleteShipmentCertificateRequest
 */
export interface ShipmentCertificatesApiDeleteShipmentCertificateRequest {
    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiDeleteShipmentCertificate
     */
    readonly id: string
}

/**
 * Request parameters for getIssueSuggestDate operation in ShipmentCertificatesApi.
 * @export
 * @interface ShipmentCertificatesApiGetIssueSuggestDateRequest
 */
export interface ShipmentCertificatesApiGetIssueSuggestDateRequest {
    /**
     * 
     * @type {PostShipmentCertificateRequest}
     * @memberof ShipmentCertificatesApiGetIssueSuggestDate
     */
    readonly postShipmentCertificateRequest: PostShipmentCertificateRequest
}

/**
 * Request parameters for getMaximumIssueDate operation in ShipmentCertificatesApi.
 * @export
 * @interface ShipmentCertificatesApiGetMaximumIssueDateRequest
 */
export interface ShipmentCertificatesApiGetMaximumIssueDateRequest {
    /**
     * 
     * @type {PostShipmentCertificateRequest}
     * @memberof ShipmentCertificatesApiGetMaximumIssueDate
     */
    readonly postShipmentCertificateRequest: PostShipmentCertificateRequest
}

/**
 * Request parameters for getShipmentCertificate operation in ShipmentCertificatesApi.
 * @export
 * @interface ShipmentCertificatesApiGetShipmentCertificateRequest
 */
export interface ShipmentCertificatesApiGetShipmentCertificateRequest {
    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiGetShipmentCertificate
     */
    readonly id: string
}

/**
 * Request parameters for getShipmentCertificateByKeyword operation in ShipmentCertificatesApi.
 * @export
 * @interface ShipmentCertificatesApiGetShipmentCertificateByKeywordRequest
 */
export interface ShipmentCertificatesApiGetShipmentCertificateByKeywordRequest {
    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiGetShipmentCertificateByKeyword
     */
    readonly keyword?: string

    /**
     * 
     * @type {number}
     * @memberof ShipmentCertificatesApiGetShipmentCertificateByKeyword
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof ShipmentCertificatesApiGetShipmentCertificateByKeyword
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiGetShipmentCertificateByKeyword
     */
    readonly orderBy?: string

    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiGetShipmentCertificateByKeyword
     */
    readonly orderDesc?: string

    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiGetShipmentCertificateByKeyword
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiGetShipmentCertificateByKeyword
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiGetShipmentCertificateByKeyword
     */
    readonly endDate?: string
}

/**
 * Request parameters for getWeightsProduct operation in ShipmentCertificatesApi.
 * @export
 * @interface ShipmentCertificatesApiGetWeightsProductRequest
 */
export interface ShipmentCertificatesApiGetWeightsProductRequest {
    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiGetWeightsProduct
     */
    readonly locationId: string

    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiGetWeightsProduct
     */
    readonly productName: string
    /**
     * 
     * @type {Array<string>}
     * @memberof ShipmentCertificatesApiGetWeightsProduct
     */
    readonly treatmentRequests: Array<string>
}

/**
 * Request parameters for previewShipmentCertificate operation in ShipmentCertificatesApi.
 * @export
 * @interface ShipmentCertificatesApiPreviewShipmentCertificateRequest
 */
export interface ShipmentCertificatesApiPreviewShipmentCertificateRequest {
    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiPreviewShipmentCertificate
     */
    readonly id: string
}

/**
 * Request parameters for updateShipmentCertificate operation in ShipmentCertificatesApi.
 * @export
 * @interface ShipmentCertificatesApiUpdateShipmentCertificateRequest
 */
export interface ShipmentCertificatesApiUpdateShipmentCertificateRequest {
    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiUpdateShipmentCertificate
     */
    readonly id: string

    /**
     * 
     * @type {PutShipmentCertificateRequest}
     * @memberof ShipmentCertificatesApiUpdateShipmentCertificate
     */
    readonly putShipmentCertificateRequest: PutShipmentCertificateRequest
}

/**
 * Request parameters for updateStatusShipmentCertificate operation in ShipmentCertificatesApi.
 * @export
 * @interface ShipmentCertificatesApiUpdateStatusShipmentCertificateRequest
 */
export interface ShipmentCertificatesApiUpdateStatusShipmentCertificateRequest {
    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiUpdateStatusShipmentCertificate
     */
    readonly id: string

    /**
     * 
     * @type {string}
     * @memberof ShipmentCertificatesApiUpdateStatusShipmentCertificate
     */
    readonly action: string

    /**
     * 
     * @type {CancelRemarkShipmentCertificateRequest}
     * @memberof ShipmentCertificatesApiUpdateStatusShipmentCertificate
     */
    readonly cancelRemarkShipmentCertificateRequest: CancelRemarkShipmentCertificateRequest
}

/**
 * ShipmentCertificatesApi - object-oriented interface
 * @export
 * @class ShipmentCertificatesApi
 * @extends {BaseAPI}
 */
export class ShipmentCertificatesApi extends BaseAPI {
    /**
     * 
     * @param {ShipmentCertificatesApiCreateShipmentCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentCertificatesApi
     */
    public createShipmentCertificate(requestParameters: ShipmentCertificatesApiCreateShipmentCertificateRequest, options?: AxiosRequestConfig) {
        return ShipmentCertificatesApiFp(this.configuration).createShipmentCertificate(requestParameters.postShipmentCertificateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShipmentCertificatesApiDeleteShipmentCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentCertificatesApi
     */
    public deleteShipmentCertificate(requestParameters: ShipmentCertificatesApiDeleteShipmentCertificateRequest, options?: AxiosRequestConfig) {
        return ShipmentCertificatesApiFp(this.configuration).deleteShipmentCertificate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShipmentCertificatesApiGetIssueSuggestDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentCertificatesApi
     */
    public getIssueSuggestDate(requestParameters: ShipmentCertificatesApiGetIssueSuggestDateRequest, options?: AxiosRequestConfig) {
        return ShipmentCertificatesApiFp(this.configuration).getIssueSuggestDate(requestParameters.postShipmentCertificateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShipmentCertificatesApiGetMaximumIssueDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentCertificatesApi
     */
    public getMaximumIssueDate(requestParameters: ShipmentCertificatesApiGetMaximumIssueDateRequest, options?: AxiosRequestConfig) {
        return ShipmentCertificatesApiFp(this.configuration).getMaximumIssueDate(requestParameters.postShipmentCertificateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShipmentCertificatesApiGetShipmentCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentCertificatesApi
     */
    public getShipmentCertificate(requestParameters: ShipmentCertificatesApiGetShipmentCertificateRequest, options?: AxiosRequestConfig) {
        return ShipmentCertificatesApiFp(this.configuration).getShipmentCertificate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShipmentCertificatesApiGetShipmentCertificateByKeywordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentCertificatesApi
     */
    public getShipmentCertificateByKeyword(requestParameters: ShipmentCertificatesApiGetShipmentCertificateByKeywordRequest = {}, options?: AxiosRequestConfig) {
        return ShipmentCertificatesApiFp(this.configuration).getShipmentCertificateByKeyword(
            requestParameters.keyword,
            requestParameters.limit, 
            requestParameters.page, 
            requestParameters.orderBy, 
            requestParameters.orderDesc, 
            requestParameters.status,
            requestParameters.startDate,
            requestParameters.endDate,
            options,
            ).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentCertificatesApi
     */
    public getTreatmentIdsInShipment(options?: AxiosRequestConfig) {
        return ShipmentCertificatesApiFp(this.configuration).getTreatmentIdsInShipment(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShipmentCertificatesApiGetWeightsProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentCertificatesApi
     */
    public getWeightsProduct(requestParameters: ShipmentCertificatesApiGetWeightsProductRequest, options?: AxiosRequestConfig) {
        return ShipmentCertificatesApiFp(this.configuration).getWeightsProduct(requestParameters.locationId, requestParameters.productName, requestParameters.treatmentRequests, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShipmentCertificatesApiPreviewShipmentCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentCertificatesApi
     */
    public previewShipmentCertificate(requestParameters: ShipmentCertificatesApiPreviewShipmentCertificateRequest, options?: AxiosRequestConfig) {
        return ShipmentCertificatesApiFp(this.configuration).previewShipmentCertificate(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentCertificatesApi
     */
    public statisticsDataShipment(options?: AxiosRequestConfig) {
        return ShipmentCertificatesApiFp(this.configuration).statisticsDataShipment(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShipmentCertificatesApiUpdateShipmentCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentCertificatesApi
     */
    public updateShipmentCertificate(requestParameters: ShipmentCertificatesApiUpdateShipmentCertificateRequest, options?: AxiosRequestConfig) {
        return ShipmentCertificatesApiFp(this.configuration).updateShipmentCertificate(requestParameters.id, requestParameters.putShipmentCertificateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ShipmentCertificatesApiUpdateStatusShipmentCertificateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentCertificatesApi
     */
    public updateStatusShipmentCertificate(requestParameters: ShipmentCertificatesApiUpdateStatusShipmentCertificateRequest, options?: AxiosRequestConfig) {
        return ShipmentCertificatesApiFp(this.configuration).updateStatusShipmentCertificate(requestParameters.id, requestParameters.action, requestParameters.cancelRemarkShipmentCertificateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
